import { render, staticRenderFns } from "./staffadd.vue?vue&type=template&id=010cc428&scoped=true"
import script from "./staffadd.vue?vue&type=script&lang=js"
export * from "./staffadd.vue?vue&type=script&lang=js"
import style0 from "./staffadd.vue?vue&type=style&index=0&id=010cc428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010cc428",
  null
  
)

export default component.exports